import { Glyph } from "../../types";

const SvgArrowUp: Glyph = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <rect fill="none" />
      <path d="M5,9l1.41,1.41L11,5.83V22H13V5.83l4.59,4.59L19,9l-7-7L5,9z" />
    </svg>
  );
};

export default SvgArrowUp;
